module.exports = __webpack_public_path__ + "static/media/huanjing3.43abe173.png";